<template>
  <DsShowcase title="CheckboxPlay" description="Checkbox customizado com suporte a v-model booleano, arrays e grupos com parent (check all).">
    <!-- Básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico (boolean)</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">v-model com <code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <CheckboxPlay id="cb-1" v-model="single1" name="cb-1" label="Aceito os termos de uso" />
        <CheckboxPlay id="cb-2" v-model="single2" name="cb-2" label="Receber notificações por e-mail" />
      </div>
      <p class="tw:text-xs tw:mt-3 tw:opacity-50">Valores: {{ single1 }}, {{ single2 }}</p>
    </section>

    <!-- Array -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso com array</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">v-model com <code>Array</code> — cada checkbox adiciona/remove seu <code>checkedValue</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <CheckboxPlay id="cb-apple" v-model="fruits" name="fruits" label="Maçã" checked-value="apple" />
        <CheckboxPlay id="cb-banana" v-model="fruits" name="fruits" label="Banana" checked-value="banana" />
        <CheckboxPlay id="cb-orange" v-model="fruits" name="fruits" label="Laranja" checked-value="orange" />
      </div>
      <p class="tw:text-xs tw:mt-3 tw:opacity-50">Selecionados: {{ fruits }}</p>
    </section>

    <!-- Check All (parent) -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Check All (parent)</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">
        Usa <code>:parent="true"</code> + <code>data-group</code> para marcar/desmarcar todos do grupo.
        Quando todos os filhos são marcados manualmente, o parent também fica marcado.
      </p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <CheckboxPlay
          id="cb-perm-all"
          v-model="permissions"
          name="permissions"
          label="Selecionar todos"
          :parent="true"
          data-group="permissions-demo"
          checked-value="all"
        />
        <div class="tw:ml-6 tw:flex tw:flex-col tw:gap-3">
          <CheckboxPlay
            id="cb-perm-read"
            v-model="permissions"
            name="permissions"
            label="Leitura"
            data-group="permissions-demo"
            checked-value="read"
          />
          <CheckboxPlay
            id="cb-perm-write"
            v-model="permissions"
            name="permissions"
            label="Escrita"
            data-group="permissions-demo"
            checked-value="write"
          />
          <CheckboxPlay
            id="cb-perm-delete"
            v-model="permissions"
            name="permissions"
            label="Exclusão"
            data-group="permissions-demo"
            checked-value="delete"
          />
          <CheckboxPlay
            id="cb-perm-admin"
            v-model="permissions"
            name="permissions"
            label="Administração"
            data-group="permissions-demo"
            checked-value="admin"
          />
        </div>
      </div>
      <p class="tw:text-xs tw:mt-3 tw:opacity-50">Selecionados: {{ permissions }}</p>
    </section>

    <!-- Disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <CheckboxPlay id="cb-dis-1" :model-value="true" name="cb-dis" label="Marcado e desabilitado" :disabled="true" />
        <CheckboxPlay id="cb-dis-2" :model-value="false" name="cb-dis" label="Desmarcado e desabilitado" :disabled="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { CheckboxPlay } from '@/components/atomic'

const single1 = ref(false)
const single2 = ref(true)
const fruits = ref(['banana'])
const permissions = ref<string[]>([])
</script>
